import { apiClient } from '@mb/lib';
import { AxiosResponse } from 'axios';
import { config } from '../../config';
import { GetCalendarLinkResponse } from '../../types';

export async function getCalendarLink(
  grandId: string,
  email: string,
): Promise<string> {
  const res: AxiosResponse<GetCalendarLinkResponse> = await apiClient.get(
    config.endpoints.getCalendarLink(grandId, email),
  );
  return res.data?.calendar_link ?? '';
}
